import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { NumberCons, StringConst } from '../constants/const';
import { TransformDateType } from '../model/local/general.model';

@Injectable({
  providedIn: 'root',
})
export class DateOperationService {
  constructor(private datePipe: DatePipe) {}

  transformDate(date: Date, typeTransform: TransformDateType): string {
    const dictToTransformDate: { [key: number]: string } = {
      0: this.datePipe.transform(date, 'dd/MM/yyyy') ?? StringConst.empty,
      1: this.datePipe.transform(date, 'yyyy-MM-dd') ?? StringConst.empty,
    };
    return dictToTransformDate[typeTransform];
  }
  getTimeStamp(): number {
    return new Date().getTime();
  }

  getMonthYearString(date: Date): string {
    date.setMonth(date.getMonth());
    return (
      date
        .toLocaleString('es-MX', { month: 'short' })
        .toUpperCase()
        .replace('.', '') + date.toLocaleString('es-MX', { year: '2-digit' })
    );
  }

  addDays(initDate: Date, days: number): Date {
    initDate.setDate(initDate.getDate() + days);
    return initDate;
  }
}
